import React, { useEffect, useState, useMemo, useRef } from "react";
import "../../styles/Components/Share/PrescriptionShare.scss";

import { useSelector, useDispatch } from "react-redux";
import {
  getPatientsReportView,
  getPatientsBillReportView,
} from "../../Redux/Thunk/Actions";
import {
  CRUDRecordPopup,
  menuPrescriptionTab,
  reportViewType,
  shareTemplate,
} from "../../Redux/Slice/rootSlice";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function PrescriptionShare({ loaderchange, popupalert, popuptext }) {
  const sideActive = useSelector((state) => state.counter.sidebarnav);
  const activeTab = useSelector((state) => state.counter.menuPrescriptionTab);
  console.log(activeTab, "test");
  const reportViewId = useSelector((state) => state.counter.reportViewId);
  let recordpopup = useSelector((state) => state.counter.recordpopup);
  const [response, setResponse] = useState();
  const fetchReportViewType = useSelector(
    (state) => state.counter.reportViewTypeData
  );
  const [recordCRUDpopup, setRecordCRUDpopup] = useState(recordpopup);
  const dispatch = useDispatch();
  const [reportView_Type, setReportView_Type] = useState("");
  const [printTrigger, setPrintTrigger] = useState(false);

  useEffect(() => {
    const handleThunk = async (props) => {
      loaderchange(true);
      const payload = reportViewId;
      let patentDetails;
      if (fetchReportViewType === "Patient Billing") {
        patentDetails = getPatientsBillReportView(payload);
      } else if (fetchReportViewType === "Patient Reports") {
        patentDetails = getPatientsReportView(payload);
      }
      const response = await dispatch(patentDetails);
      // dispatch(reportViewType(""));
      if (response?.payload?.status?.code === 200) {
        loaderchange(false);
        setResponse(response.payload.data.report_template);
        // setResponse(response.payload.data.prescription_template);
      } else {
        loaderchange("false");
        popupalert("true");
        popuptext("Network went wrong billing, Please try after some time.");
        popuptext(response?.status?.message);
        setTimeout(() => {
          popupalert("false");
        }, 2000);
      }
    };
    setReportView_Type(fetchReportViewType);
    // handleThunk();
  }, []);

  const PrintDiv = () => {
    setPrintTrigger(!printTrigger);
    var new_str = document.getElementById("demo").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = new_str;
    window.print();
    document.body.innerHTML = originalContents;
    return false;
  };

  var mediaQueryList = window.matchMedia("print");
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log("before print dialog open");
    } else {
      window.location.reload();
      console.log("after print dialog closed");
    }
  });
  const divRef = useRef(null);
  const Share = async (e) => {};
  console.log("from prescc");

  return (
    <>
      <div style={{ paddingTop: "30px" }}>
        {/* {recordCRUDpopup && 
      <RecordCRUD
        setclosepopup = {setRecordCRUDpopup}
        loaderchange={loaderchange}
        patientid_share = {patientId}
      />} */}
        <div className="pageWrappers">
          <div className="content container-fluid">
            {/* Page Header Start */}
            {/* <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">History</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={
                          fetchReportViewType === "Patient Billing"
                            ? "/patient_billing"
                            : "/patientreports"
                        }
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        {fetchReportViewType === "Patient Billing"
                          ? "Patient Billing"
                          : "Patient Reports"}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">History</li>
                  </ul>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="buttonHeader">
                <button
                  className="addPatientRecordbtn"
                  //   onClick={handleAddPrescription}
                  style={{ marginRight: "20px" }}
                  onClick={(e) => {
                    PrintDiv();
                  }}
                >
                  Print
                </button>
              </div>
            </div>
            <div className="profile-menu" id="demo" ref={divRef}>
              <ul
                className="nav nav-tabs"
                role="tablist"
                style={{ padding: "15px" }}
              >
                {" "}
                <button
                  className={`nav-link${
                    // "prescription" === "prescription" ? " active" : ""
                    true ? " active" : ""
                  } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="prescription"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => {
                    dispatch(menuPrescriptionTab(e.target.name));
                  }}
                  style={{ marginRight: "5px" }}
                >
                  {fetchReportViewType === "Patient Billing"
                    ? "Patient Billing"
                    : "Patient Reports"}
                </button>
                {/* <button
                  className={`nav-link${
                    activeTab === "p_records" ? " active" : ""
                  } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="p_records"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => handleTabClick(e)}
                  style={{ marginRight: "10px" }}
                >
                  Patient records
                </button> */}
              </ul>
              {/* activeTab=="prescription"&&<div */}
              <div
                className="report_view_new"
                style={{
                  maxWidth: "1150px",
                  margin: printTrigger && "0 auto",
                }}
                // style={{ maxWidth: "650px" }}
                dangerouslySetInnerHTML={{
                  __html: response,
                }}
              ></div>
              {/* {
                activeTab=="p_records"&&<PatientRecords
                loaderchange={loaderchange}
                patientId={patientId}
                typeshow={"prescription_specific"}
              />
              } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrescriptionShare;
